export default {"src":"/_next/static/media/twitter-solid.0a6d8093.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};